"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidHmfVariable = isValidHmfVariable;
exports.isValidHmfColor = isValidHmfColor;
exports.getHmfVarValue = getHmfVarValue;
/* Warning: these do not work in SSR, getComputedStyle is undefined */
function isValidHmfVariable(hmfVar) {
  const value = getComputedStyle(document.body).getPropertyValue(hmfVar);
  return value.length > 0;
}
function isValidHmfColor(colorVar) {
  if (isValidHmfVariable(colorVar)) {
    const value = getHmfVarValue(colorVar);
    return /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(value);
  }
  return false;
}
function getHmfVarValue(hmfVar) {
  return getComputedStyle(document.body).getPropertyValue(hmfVar);
}
